import { getIdToken } from 'src/services/authService';
import type { IAuthMe } from 'src/models/interfaces/IAuthMe';

const API_BASE = (process.env.REACT_APP_API_BASE_URL ?? '').replace(/\/$/, '');

export async function getAuthMe(): Promise<IAuthMe> {
  const token = await getIdToken();
  const response = await fetch(`${API_BASE}/api/Auth/me`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) throw new Error(`Auth/me: ${response.status}`);
  return response.json();
}
